/* eslint-disable no-unused-vars */
import Vue from 'vue'

// styles
import '../node_modules/material-design-icons-iconfont/dist/material-design-icons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import './assets/styles/main.scss'

// essentials
import App from './App.vue'
import router from './router'
import store from './store'

// plugins
import './plugins/global.mixins'
import vuetify from './plugins/vuetify'

// auth - google
import GAuth from 'vue-google-oauth2'
const gauthOption = {
  clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(GAuth, gauthOption)
Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  data () {
    return {
      spinners: {
        main: false
      }

    }
  }
}).$mount('#app')
